exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".split-bg-right[data-v-6bfa89f1]{background-image:url(https://placehold.co/1920x1080/F9F5F0/F9F5F0?text=Wood+Texture);background-size:cover;background-position:50%;position:relative}.login-container[data-v-6bfa89f1]{min-height:100vh;overflow:hidden}.arch-image-container[data-v-6bfa89f1]{border-top-left-radius:50% 20%;border-top-right-radius:50% 20%;overflow:hidden;height:400px;width:100%;max-width:400px;margin:0 auto}", ""]);

// exports
